import { useMemo } from "react";
import { nameToHslColor } from "@circle-react-uikit/UserImage/name";
import { useImageDominantColor } from "@/react/hooks/useImageDominantColor";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { CommunityMember } from "@circle-react/types";

interface MemberGradientBackgroundProps {
  className?: string;
  member: CommunityMember;
}

/**
 * @description
 * Place this inside a parent with the className "relative"
 */
export const MemberGradientBackground = ({
  member,
  className,
}: MemberGradientBackgroundProps) => {
  const { rgba } = useImageDominantColor({
    imageUrl: member.avatar_url,
    fallbackColor: nameToHslColor(member.name ?? ""),
    enabled: Boolean(member.avatar_url),
  });

  const gradientStyle = useMemo(() => {
    // Replace the alpha value with 0.16 (16% opacity)
    // Parse rgba(r, g, b, a) and replace alpha with 0.16
    const rgbaRegex = /rgba\((\d+),\s*(\d+),\s*(\d+)/;
    const parts = rgbaRegex.exec(rgba);
    const rgbaWith16Opacity = parts
      ? `rgba(${parts[1]}, ${parts[2]}, ${parts[3]}, 0.12)`
      : rgba;

    return {
      background: `linear-gradient(180deg, ${rgbaWith16Opacity} 0%, rgba(255, 255, 255, 0) 50%)`,
    };
  }, [rgba]);
  return (
    <div
      className={classNames(
        "pointer-events-none absolute inset-3 z-0 rounded-lg",
        className,
      )}
      style={gradientStyle}
      aria-hidden="true"
    />
  );
};
